<template>
    <div class="d-flex align-center mr-2">
        <div class="ml-4 text-h5 font-weight-light">
            Partner Portal
        </div>
        <div class="flex-grow-1">
            <slot></slot>
        </div>

        <!--Partners Tab-->
        <template v-if="$store.state.ref.partner.tabIndex === 3">
            <div style="width: 300px">
                <v-text-field
                        placeholder="Search"
                        hide-details
                        class="pa-0 ma-0 mx-2"
                        color="primary"
                        prepend-inner-icon="mdi-magnify"
                        solo
                        dense
                        v-model="$store.state.ref.partner.partners.filterStr"
                ></v-text-field>
            </div>

            <v-btn
                    small
                    outlined
                    color="primary"
                    class="mx-2"
                    @click="$store.state.ref.partner.partners.showCreatePartner = true"
            >
                New Partner
            </v-btn>
        </template>

<!--Sites Tab-->
        <template v-if="$store.state.ref.partner.tabIndex === 1">
            <div style="width: 300px">
                <v-text-field
                        placeholder="Search"
                        hide-details
                        class="pa-0 ma-0 mx-2"
                        color="primary"
                        prepend-inner-icon="mdi-magnify"
                        solo
                        dense
                        v-model="$store.state.ref.partner.sites.filterStr"
                ></v-text-field>
            </div>
        </template>
    </div>
</template>

<script>
import {
    addDays,
    endOfDay, endOfMonth,
    format, isMonday,
    isSameDay,
    isSameMonth,
    isSameYear,
    startOfDay, startOfMonth,
    subDays, subMonths, subWeeks
} from "date-fns";

const calFmt = (date) => {
    try {
        return format(date, 'yyyy-MM-dd')
    } catch (e) {
        return null;
    }
}

export default {
    props: {
        shown: Boolean,
    },
    data() {
        return {
            resetDtPicker: false,
            dateMenu: false,
            maxDate: (() => {return calFmt(new Date)})(),
            filters: [
                {
                    title: "Today",
                    cb: (title) => {
                        return {
                            title: title,
                            start: startOfDay(new Date()),
                            end: endOfDay(new Date()),
                        }
                    }
                },
                {
                    title: "Yesterday",
                    cb: (title) => {
                        return {
                            title: title,
                            start: startOfDay(subDays(new Date(), 1)),
                            end: endOfDay(subDays(new Date(), 1)),
                        }
                    }
                },
                {
                    title: "This Week",
                    cb: (title) => {
                        let start = new Date()
                        while (!isMonday(start))
                            start = subDays(start, 1)
                        return {
                            title,
                            start: start,
                            end: new Date(),
                        }
                    }
                },
                {
                    title: "Last Week",
                    cb: (title) => {
                        let start = subWeeks(new Date(), 1)
                        while (!isMonday(start))
                            start = subDays(start, 1)
                        return {
                            title,
                            start: start,
                            end: addDays(start, 6)
                        }
                    }
                },
                {
                    title: "This Month",
                    cb: (title) => {
                        return {
                            title,
                            start: startOfMonth(new Date()),
                            end: new Date(),
                        }
                    }
                },
                {
                    title: "Last Month",
                    cb: (title) => {
                        return {
                            title,
                            start: startOfMonth(subMonths(new Date(), 1)),
                            end: endOfMonth(subMonths(new Date(), 1)),
                        }
                    }
                },
            ],
        }
    },
    watch: {
        resetDtPicker(val) {
            if (val)
                this.$nextTick(() => {
                    this.resetDtPicker = false
                })
        }

    },
    methods: {

        exportDashboardData() {
            this.$emit('exportDashboardData')
        },

        setDates({start, end, title}) {
            this.range.title = title
            this.range.start = start;
            this.range.end = end;
            this.dateMenu = false
        }
    },
    computed: {

        range() {
            return this.$store.state.ref.dashboard.selectedRange
        },
        dateTitle() {
            // TODO Add Here
            // if (this.range.title)
            //     return this.range.title
            if (!isSameYear(this.range.start, this.range.end))
                return `${format(this.range.start,'dd MMM yyyy')} - ${format(this.range.end,'dd MMM yyyy')}`
            if (!isSameMonth(this.range.start, this.range.end))
                return `${format(this.range.start,'dd MMM')} - ${format(this.range.end,'dd MMM yyyy')}`
            if (!isSameDay(this.range.start, this.range.end))
                return `${format(this.range.start,'dd')} - ${format(this.range.end,'dd MMM yyyy')}`
            return format(this.range.end,'dd MMM yyyy')
        },
        dates: {
            get() {
                return isSameDay(this.range.start, this.range.end) ? [calFmt(this.range.start, 'yyyy-MM-dd')] : [calFmt(this.range.start, 'yyyy-MM-dd'), calFmt(this.range.end, 'yyyy-MM-dd')]
            },
            set(dates) {
                if (!dates || !dates.length) {
                    this.range.start = new Date();
                    this.range.end = new Date();
                    return;
                }
                if (dates.length === 1) {
                    this.range.start = new Date(dates[0]);
                    this.range.end = new Date(dates[0]);
                } else {
                    const dt1 = new Date(dates[0]);
                    const dt2 = new Date(dates[1]);
                    this.range.start = dt1 < dt2 ? dt1 : dt2;
                    this.range.end = dt1 < dt2 ? dt2 : dt1;
                }
            }
        }
    },
}
</script>

<style scoped>

</style>